var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRelaxation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Relaxation/Transparent - WithoutCircle",
    clipPath: "url(#clip0_577_171098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Relaxation"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M186.314 126.496C186.314 126.496 194.356 95.4085 172.801 74",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M175.477 124.748C175.477 124.748 182.482 97.6586 163.707 79.003",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M165.964 124.74C165.964 124.74 171.894 101.816 156.002 86.0248",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M69.4685 126.496C69.4685 126.496 61.4265 95.4085 82.9816 74",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M80.3063 124.748C80.3063 124.748 73.3007 97.6586 92.0841 79.003",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M89.8185 124.74C89.8185 124.74 83.8895 101.816 99.7806 86.0248",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M154.717 113.274C154.717 77.1278 101.251 74.9415 101.251 113.274",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M127.98 124.732C135.376 124.732 141.372 118.777 141.372 111.431C141.372 104.085 135.376 98.1295 127.98 98.1295C120.583 98.1295 114.587 104.085 114.587 111.431C114.587 118.777 120.583 124.732 127.98 124.732Z",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M107.051 164.11V144.425C107.051 144.425 109.14 124.748 127.98 124.748C146.82 124.748 148.547 144.034 148.547 144.034V165.052",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M136.721 176.015C136.568 178.186 135.098 180.268 132.832 181.242C131.973 181.609 130.993 181.816 129.924 181.808H104.697C104.649 181.808 88.991 181.8 88.991 171.882C88.991 160.448 101.516 162.73 101.516 162.73L131.097 169.696C135.299 170.845 136.898 173.494 136.721 176.015Z",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M129.667 181.808H158.501C164.759 181.808 169.499 177.124 168.543 170.877C166.768 161.94 153.801 164.318 153.801 164.318L128.462 169.065",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_577_171098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelaxation);
export default __webpack_public_path__ + "static/media/Relaxation.bb63bb0e20186a52e5ea58c31a7f4005.svg";
export { ForwardRef as ReactComponent };